module.exports = __webpack_public_path__ + "img/smartlinks_logo.1a75b935.png";